import React, { Component, forwardRef } from 'react';
import { Link } from 'react-router-dom';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import Collapse from '@material-ui/core/Collapse';
import { connect } from 'react-redux';
import { showHideScreenSize } from '../../actions/ShowHide';

const ListItemLink = (props) => {
  const { primary, to, showHideScreenSize, padded } = props;

  const renderLink = React.useMemo(
    () =>
      forwardRef((itemProps, ref) => (
        <Link to={to} {...itemProps} innerRef={ref} />
      )),
    [to]
  );

  return (
    <li>
      <ListItem
        button
        component={renderLink}
        onClick={() => showHideScreenSize(false)}
      >
        <ListItemText className={padded ? 'pl-3' : ''} primary={primary} />
      </ListItem>
    </li>
  );
};

class SidebarMenu extends Component {
  componentDidUpdate(prevProps, prevState, snapshot) {
    !!!this.props.menu && this.props.dropDown && this.props.dropShowHide();
    !!!prevProps.dropDown &&
      this.props.dropDown &&
      setTimeout(() => this.props.dropDown && this.props.dropShowHide(), 10000);
  }

  render() {
    const { dropDown, dropShowHide, dark } = this.props;
    return (
      <List
        style={{
          paddingTop: '70px',
        }}
      >
        <ListItemLink to="/" primary="Inicio" {...this.props} />
        <ListItemLink
          to="/ObtencionLicencia"
          primary="¿Cómo obtengo mi licencia de conducir?"
          {...this.props}
        />
        <ListItem
          button
          onClick={() => dropShowHide()}
          style={{
            boxShadow: dropDown ? '0 6px 4px -1px rgba(0, 0, 0, 0.2)' : '',
            zIndex: 99999,
          }}
        >
          <ListItemText primary="Prepara tu examen Teórico y Práctico" />
          {dropDown ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={dropDown} timeout={500} unmountOnExit>
          <List
            component="div"
            style={{
              backgroundColor: dark ? '#333333' : '#e1e1e1',
            }}
          >
            <ListItemLink
              padded
              to="/LicenciaClaseB"
              primary="Clase B (Autos)"
              {...this.props}
            />
            <ListItemLink
              padded
              to="/LicenciaClaseB-ENG"
              primary="Class B (Cars)/ Clase B en inglés"
              {...this.props}
            />
            <ListItemLink
              padded
              to="/LicenciaClaseC"
              primary="Clase C (Motos)"
              {...this.props}
            />
            <ListItemLink
              padded
              to="/LicenciaClaseCR"
              primary="Clase C Restringida (Triciclos Motorizados de Carga)"
              {...this.props}
            />
            <ListItemLink
              padded
              to="/LicenciaClaseA1"
              primary="Clase A1 (Taxis)"
              {...this.props}
            />
            <ListItemLink
              padded
              to="/LicenciaClaseA2"
              primary="Clase A2 (Vehículos de pasajeros peq. y med.)"
              {...this.props}
            />
            <ListItemLink
              padded
              to="/LicenciaClaseA3"
              primary="Clase A3 (Todo vehículo de pasajeros)"
              {...this.props}
            />
            <ListItemLink
              padded
              to="/LicenciaClaseA4"
              primary="Clase A4 (Camiones simples sin acoplado)"
              {...this.props}
            />
            <ListItemLink
              padded
              to="/LicenciaClaseA5"
              primary="Clase A5 (Todo camión)"
              {...this.props}
            />
            <ListItemLink
              padded
              to="/LicenciaClaseD"
              primary="Clase D (Maquinaria)"
              {...this.props}
            />
            <ListItemLink
              padded
              to="/LicenciaClaseE"
              primary="Clase E (Tracción Animal)"
              {...this.props}
            />
          </List>
        </Collapse>
        <ListItemLink
          to="/licenciaClaseA1A2"
          primary="Sobre las Clases A1 y A2 antiguas"
          {...this.props}
        />
        <ListItemLink
          to="/Ciclos"
          primary="Material educativo para ciclistas"
          {...this.props}
        />
        <ListItemLink
          to="/DudasFrecuentes/faqExtranjeros"
          primary="Postulantes extranjeros"
          {...this.props}
        />
        <ListItemLink
          to="/TipsCiclos"
          primary="Convivencia de vehículos motorizados con ciclos"
          {...this.props}
        />
        <ListItemLink
          to="/DudasFrecuentes/LicenciaClaseB"
          primary="Dudas Frecuentes"
          {...this.props}
        />
        <ListItemLink
          to="/FileManager/Leyes"
          primary="Biblioteca y Normativa Aplicable"
          {...this.props}
        />
        <ListItemLink
          to="/dudasSugerencias"
          primary="¿Dudas y Sugerencias?"
          {...this.props}
        />
        <ListItemLink to="/Fyac" primary="Nosotros" {...this.props} />
      </List>
    );
  }
}

const mapStateToProps = (state) => ({
  dark: state.dark,
  menu: state.menu.desktop,
});

export default connect(mapStateToProps, { showHideScreenSize })(SidebarMenu);
